import { social } from "../lib/profile";

export function Contact() {
  return (
    <section className="contact" id="contact">
      <span className="eyebrow" data-reveal>
        Let&rsquo;s work together
      </span>
      <h2 className="contact__title" data-reveal>
        Have a project in mind?
        <br />
        I&rsquo;d love to hear about it.
      </h2>
      <a className="contact__mail" href={`mailto:${social.email}`} data-reveal>
        {social.email}
      </a>
      <div className="contact__links" data-reveal>
        <a href={social.github} target="_blank" rel="noreferrer">
          GitHub
        </a>
        <a href={social.linkedin} target="_blank" rel="noreferrer">
          LinkedIn
        </a>
        <a href={social.soundcloud} target="_blank" rel="noreferrer">
          SoundCloud
        </a>
      </div>
    </section>
  );
}
